import * as React from 'react';
import { SVGProps } from 'react';

const IconGeoSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 6.727C13 10.273 8 15 8 15s-5-4.727-5-8.273C3 4.007 5.239 2 8 2s5 2.008 5 4.727zM8 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
    />
  </svg>
);
export default IconGeoSizeS;
